import gql from "graphql-tag";
import client from "@/http/graphql/request";

function decoded(response, field) {
    if (response.errors && response.errors.length) throw new Error(response.errors[0].message);
    return JSON.parse(response.data[field]);
}
export default {
    settings(stepId) {
        return client.query({ query: gql`query($id: Int!) { alternative_approver_settings(step_id: $id) }`, variables: { id: Number(stepId) }, fetchPolicy: "network-only" })
            .then(r => decoded(r, "alternative_approver_settings"));
    },
    save(stepId, settings, revision) {
        return client.mutate({ mutation: gql`mutation($id: Int!, $settings: String!, $revision: Int!) { save_alternative_approver_settings(step_id: $id, settings: $settings, revision: $revision) }`,
            variables: { id: Number(stepId), settings: JSON.stringify(settings), revision } }).then(r => decoded(r, "save_alternative_approver_settings"));
    },
    options(typeId) {
        return client.query({ query: gql`query($id: Int!) { alternative_approver_options(req_type_id: $id) }`, variables: { id: Number(typeId) }, fetchPolicy: "network-only" })
            .then(r => decoded(r, "alternative_approver_options"));
    },
    history(requestId) {
        return client.query({ query: gql`query($id: Int!) { request_approver_selections(request_id: $id) }`, variables: { id: Number(requestId) }, fetchPolicy: "network-only" })
            .then(r => decoded(r, "request_approver_selections"));
    }
};
